import axios from 'axios';
import { handleError } from '@/shared/services/api';

export default {
  baseUrl(id = null) {
    let url = `${window.api_url}/organization/grants`;
    if (id) url += `/${id}`;
    return url;
  },

  create(grant, success, failure) {
    axios.post(this.baseUrl(), { grant }).then(success).catch(failure);
  },

  destroy(id, success) {
    axios.delete(this.baseUrl(id)).then(success);
  },

  downloadUrl(id, filename) {
    return `${this.baseUrl(id)}.pdf?filename=${encodeURIComponent(filename)}.pdf`;
  },

  get(id, success) {
    if (!success) return axios.get(this.baseUrl(id)).catch(handleError);
    return axios.get(this.baseUrl(id)).then(success);
  },

  index(filters, success) {
    axios.get(this.baseUrl(), { params: filters }).then(success);
  },

  update(id, grant, success, failure) {
    if (!success) return axios.patch(this.baseUrl(id), { grant }).catch(handleError);
    return axios.patch(this.baseUrl(id), { grant }).then(success).catch(failure);
  },
};
